import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { PackageService } from 'src/app/services/package.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-packages-details',
  standalone: true,
  imports: [
        SafeHtmlPipe,
        ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './packages-details.component.html',
  styleUrl: './packages-details.component.scss'
})
export class PackagesDetailsComponent {
plans:any
  constructor(
    private packageService:PackageService,
    private snackbar: SnackbarService
  ) { }

  ngOnInit() {
    this.getAllPackages()
  }
getAllPackages() {
  this.packageService.getAllPackages().subscribe(
    (res) => {
     this.plans = res['data']['plans'];
    },
    (err) => {
      this.snackbar.openSnackBar(err['msg'], 'error');
    }
  )
}

freeSubscribe(){
  this.snackbar.openSnackBar('تم الاشتراك بالباقة المجانية بنجاح', 'success');
}
}
